import axios from "@/plugins/axios";


export default {
    findByCreditorMonth(creditor, month, year){
        return axios.httpApi.get("/forecasts", {params:{creditor:creditor, month:month, year:year, limit:3000}});
    },
    createForecastMonth(forecastDays){ 
        return axios.httpApi.post("/forecasts", forecastDays);
    } ,
    updateForecast(alteracoes, id_dia){ 
        return axios.httpApi.patch("/forecasts/"+ id_dia, alteracoes);
    },
    removerForecast(responsavel, id_dia){ 
        return axios.httpApi.delete("/forecasts/"+ id_dia, {params:{user:responsavel}} );
    },
    findByMonth(month, year){
        return axios.httpApi.get("/forecasts", {params:{month:month, year:year, limit:3000}});
    },
    findTotalBudget(month, year){
        return axios.httpApi.get("/forecast/total_budget", {params:{month:month, year:year, limit:3000}});
    },
    addAdditionalForecast(params){
        return axios.httpApi.post("/forecast/additional", params);
    }
}